import { RecentReportCard, type RecentReport } from "./recent-report-card";

interface RecentReportsSectionProps {
  reports: RecentReport[];
  isAuthorLoading?: boolean;
  onSelect?: (reportId: string) => void;
}

// ============================================
// RecentReportsSection
// "최근 수정한 DSD 워크북" 라벨 + 카드 나열. 비어 있으면 안내 메시지. 순수 표현.
// 카드는 grid-cols-3으로 항상 1/3 폭 고정 — 개수가 적어도 stretch 하지 않는다.
// ============================================

export const RecentReportsSection = ({
  reports,
  isAuthorLoading,
  onSelect,
}: RecentReportsSectionProps) => {
  return (
    <section className="flex flex-col gap-2 w-full">
      <h2 className="label-1-normal-semibold text-label-normal">
        최근 수정한 DSD 워크북
      </h2>

      {reports.length === 0 ? (
        <div className="flex items-center justify-center rounded-xl bg-background-neutral-alternative py-8 caption-1-medium text-label-alternative">
          최근 수정한 DSD 워크북이 없습니다.
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-2 p-4 rounded-xl bg-background-neutral-alternative">
          {reports.map((report) => (
            <RecentReportCard
              key={report.id}
              report={report}
              isAuthorLoading={isAuthorLoading}
              onClick={() => onSelect?.(report.id)}
              className="min-w-0"
            />
          ))}
        </div>
      )}
    </section>
  );
};
